import React, { useContext } from 'react';
import HmiContext from '../../context/HmiContext';
import AppLogo from '../AppLogo/AppLogo';
import FormatMessage from '../../messages/FormatMessage';

const HmiRating: React.FC = () => {
  const hmiContext = useContext(HmiContext);
  const { parentApp } = hmiContext.hmi;

  if (!parentApp) {
    return null;
  }

  const { info } = parentApp;

  return (
    <div>
      <div className={'hmi-section-title'}>
        <FormatMessage id={'hmi.rating.title'} values={{ name: info.name }} />
      </div>
      <div className={'hmi-text-grey'}>
        <FormatMessage
          id={'hmi.rating.description.withDataDebit'}
          values={{ name: info.name }}
        />
      </div>
      <AppLogo
        src={info.graphics.logo.normal}
        rating={info.rating.score}
        ratingPoints={info.rating.points}
      />
    </div>
  );
};

export default HmiRating;
